import { getHttpDistoryHeader, getHttpGetHeader, getHttpPatchHeader, getHttpPostHeader, getHttpUpdateHeader, getServerIp, httpHeader, toastError, toastSuccess } from "./apiUtils"
import i18next from '../services/i18n/i18n'
import { request } from "./RequestManager"

const BASE_PATH = 'devices-service'


const all = async (page=1, limit=8) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/?${new URLSearchParams({ limit, page })}`
    const header = getHttpGetHeader()
    
    try {
        const req    = await request(url, header)

        if(req.status === 200){
            return await req.json()
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}


const get = async (id) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/${id}`
    const header = getHttpGetHeader()
    
    try {
        const req    = await request(url, header)

        if(req.status === 200){
            return await req.json()
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}

const create = async (data) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/`
    // if(data.activePlaylist === undefined) { data.activePlaylist = null }
    const header = getHttpPostHeader(data)
    
    try {
        const req    = await request(url, header)
        const body   = await req.json()

        if(req.status === 201){
            return body
        }
        else if(req.status === 403){
            window.location.href="/login"
        }
        else if(req.status === 405){
            window.location.href = "/setup-account"
        }
        else if(body?.detail){
            throw Error(body?.detail)
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}

const patch = async (id, data) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/${id}/`
    const header = getHttpPatchHeader(data)
    
    try {
        const req    = await request(url, header)
        
        if(req.status === 200){
            return await req.json()
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}

const update = async (id, data) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/${id}/`
    const header = getHttpUpdateHeader(data)
    
    try {
        const req    = await request(url, header)
        
        if(req.status === 200){
            return await req.json()
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}

const distroy = async (id) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/${id}/`
    const header = getHttpDistoryHeader()
    
    try {
        const req    = await request(url, header)
        
        if(req.status === 204){
            toastSuccess(i18next.t('toast_deleted'))
            return true
        }
        else if(req.status === 405){
            toastError(i18next.t('error_not_allowed_to_delete'))
            return true
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}


const assignPlaylist = async (deviceID, playlistID) => {
    const url = `${getServerIp()}api/cv/${BASE_PATH}/assign-playlist/`
    const header = getHttpPostHeader({deviceID, playlistID})
    
    try {
        const req    = await request(url, header)

        if(req.status === 202){
            return await req.json()
        }
        else if(req.status === 403){
            window.location.href="/login"
        }

        throw Error(req.statusText)
    } 
    catch (error) {
        throw Error(error.message)
    }
}

const DevicesService = {
    all, get, create, patch, distroy, update, assignPlaylist
}

export default DevicesService















